module.exports = __webpack_public_path__ + "static/media/no-search-results.0aa2912f.svg";